import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

export type Async<T> = Promise<T> | Observable<T>

export interface StateStorage {
	getItem<T extends Record<string, any>>(key: string): Async<T | null | undefined>
	setItem(key: string, value: Record<string, any>): Async<any>
	removeItem(key: string): Async<boolean | void>
}

@Injectable({ providedIn: 'root' })
export abstract class StorageStrategy implements StateStorage {
	abstract getItem<T extends Record<string, any>>(key: string): Async<T | null | undefined>

	abstract removeItem(key: string): Async<boolean | void>

	abstract setItem(key: string, value: Record<string, any>): Async<any>
}
